import { useSelector } from 'react-redux';
import { withBranding, UNAUTHENTICATED } from '~/components/branding';
import { RequestReset, LinkWasSent } from '~/components/password/RequestReset';
import { getResetLinkWasSent } from '~/store/password/selectors';

const RequestPasswordReset = () => {
  const linkWasSent = useSelector(getResetLinkWasSent);
  if (linkWasSent) {
    return <LinkWasSent />;
  }

  return <RequestReset caption="Request a password reset" />;
};

export default withBranding(UNAUTHENTICATED)(RequestPasswordReset);
